import React from 'react'

const ErrorMessage = ({error}) => {
  return (
    <p className="errorMessage">{JSON.stringify(error)}</p>
  )
}

export default ErrorMessage